export const redirect = (toPath = '', fromRoute = '') => {
  const toSanitized = sanitizePath(toPath)
  const fromSanitized = sanitizePath(fromRoute)
  const from = fromSanitized != '' ? `?from=${fromSanitized}` : ''
  let newUrl = `${process.env.VUE_APP_V3_URL}/${toSanitized}${from}`
  window.location.assign(newUrl)
}

const sanitizePath = path => {
  return path.includes('/', 0) ? path.replace('/', '') : path
}
